"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
const KeyCode = tslib_1.__importStar(require("../../util/KeyboardEventCodes"));
const StyledButton_1 = tslib_1.__importDefault(require("../../buttons/StyledButton"));
const ButtonStyle_1 = tslib_1.__importDefault(require("../../buttons/ButtonStyle"));
const DropdownUtil_1 = tslib_1.__importDefault(require("../../dropdown/DropdownUtil"));
const TextFieldWithImage_1 = tslib_1.__importDefault(require("../fields/TextFieldWithImage"));
// Component rendered in the user interface
// <div role="combobox" aria-owns="list-box" aria-haspopup="listbox" class="auto-suggest-container">
//   <label for="input-id">label-text</label>
//   <div>
//      <div>
//          <div>
//              <src="/fmk/styles/images/search.svg" alt="Søg">
//              <input id="input-id"
//                  autocomplete="off"
//                  spellcheck="false"
//                  aria-autocomplete="list"
//                  type="text"
//                  placeholder="Søg">
//          </div>
//          <ul id="list-box" role="listbox" class="auto-suggest-menu">
//              <li role="option"></li>
//              ...
//          </ul>
//      </div>
//      <button>Nulstil</button>
//   </div>
// </div>
/**
 * @deprecated Use {@link WCAGSearchField} instead.
 */
class AutoSuggestBox extends InputWidget_1.default {
    constructor(label, searchInitially = false) {
        super(document.createElement("input"), false, false);
        this.label = label;
        this.suggestions = [];
        this.suggestionsElements = [];
        this.optionToIndexMap = new Map();
        this.scrollListener = () => {
            this.renderTopOrBottom();
        };
        this.currentSelectionIndex = -1;
        this.minQueryLength = 2;
        this.isSuggestionFormatHtml = false;
        this.decorateElement(this._input);
        this.timer = new fmko_ts_common_1.FunctionalTimer(this.onTimerTriggered.bind(this));
        if (searchInitially) {
            this.timer.schedule();
        }
    }
    getValue() {
        return this.isOutOfSync() ? undefined : super.getValue();
    }
    isOutOfSync() {
        // Out-of-sync means: User has walked away from this widget with some text in the input field that doesn't match
        // the current value.
        return this.value && this.format(this.value) !== this.getInput().value;
    }
    formatSuggestion(suggestion) {
        return this.format(suggestion);
    }
    isShowingSuggestions() {
        return this.showingSuggestions;
    }
    addBlurHandler(handler) {
        if (!this.blurHandlers) {
            this.blurHandlers = [];
        }
        this.blurHandlers.push(handler);
    }
    getMinQueryLength() {
        return this.minQueryLength;
    }
    setMinQueryLength(minQueryLength) {
        this.minQueryLength = minQueryLength;
    }
    reset() {
        while (this.suggestionsList.firstChild) {
            this.suggestionsList.removeChild(this.suggestionsList.firstChild);
        }
        this.value = undefined;
        this.currentSelectionIndex = -1;
        this.currentLiHighlightedLi = undefined;
        this.suggestions = [];
        this.suggestionsElements = [];
        this.optionToIndexMap.clear();
        this.moreSuggestions = false;
        this.getInput().value = "";
        this.textFieldValueStr = "";
        this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(this.value));
    }
    getCurrentSelectionIndex() {
        return this.currentSelectionIndex;
    }
    hideSuggestions() {
        (0, fmko_ts_common_1.setElementVisible)(this.suggestionsList, false);
        this.showingSuggestions = false;
        this.element.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
        window.removeEventListener("scroll", this.scrollListener, true);
    }
    decorateElement(_) {
        const inputId = fmko_ts_common_1.GlobalCounter.next();
        const ulId = fmko_ts_common_1.GlobalCounter.next();
        const textFieldWithImage = new TextFieldWithImage_1.default({
            imageAlt: "Søg",
            imageSrc: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.SEARCH)
        });
        this._input = textFieldWithImage.getInput();
        this._input.id = inputId;
        this._input.placeholder = "Søg ...";
        this._input.autocomplete = "off";
        this._input.spellcheck = false;
        this._input.setAttribute(fmko_ts_common_1.ARIA.AUTOCOMPLETE, "list");
        this.element = document.createElement("div");
        this.element.setAttribute("role", fmko_ts_common_1.ARIARole.COMBO_BOX);
        this.element.setAttribute(fmko_ts_common_1.ARIA.HAS_POPUP, fmko_ts_common_1.ARIARole.LIST_BOX);
        this.element.setAttribute(fmko_ts_common_1.ARIA.CONTROLS, ulId);
        const autoSuggestLabel = document.createElement("label");
        autoSuggestLabel.textContent = this.label;
        autoSuggestLabel.htmlFor = inputId;
        const inputAndDropdown = document.createElement("div");
        const inputAndClearButtonContainer = document.createElement("div");
        const clearButton = new StyledButton_1.default(ButtonStyle_1.default.DEFAULT, "Nulstil", () => {
            this.reset();
        });
        this.element.classList.add("auto-suggest-container");
        this.suggestionsList = document.createElement("ul");
        this.suggestionsList.id = ulId;
        this.suggestionsList.setAttribute("role", fmko_ts_common_1.ARIARole.LIST_BOX);
        this.suggestionsList.classList.add("auto-suggest-menu");
        this.suggestionsList.addEventListener("mousedown", event => {
            event.preventDefault(); // Make sure input doesn't lose focus
        });
        inputAndDropdown.appendChild(textFieldWithImage.element);
        inputAndDropdown.appendChild(this.suggestionsList);
        inputAndClearButtonContainer.appendChild(inputAndDropdown);
        inputAndClearButtonContainer.appendChild(clearButton.element);
        this.add(autoSuggestLabel);
        this.add(inputAndClearButtonContainer);
        (0, fmko_ts_common_1.setElementVisible)(this.suggestionsList, false);
        this.showingSuggestions = false;
        this.element.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "false");
        this.addListeners(this._input);
    }
    onQueryStringChanged() {
        // Template method, for subclasses to override
    }
    populateSuggestions(suggestions, showSuggestions, moreSuggestions = false) {
        this.suggestions = suggestions || [];
        this.moreSuggestions = moreSuggestions;
        while (this.suggestionsList.firstChild) {
            this.suggestionsList.removeChild(this.suggestionsList.firstChild);
        }
        this.currentSelectionIndex = -1;
        this.currentLiHighlightedLi = undefined;
        this.suggestionsElements = [];
        this.optionToIndexMap.clear();
        if (moreSuggestions) {
            const hint = document.createElement("li");
            hint.setAttribute("role", fmko_ts_common_1.ARIARole.PRESENTATION);
            hint.classList.add("hint", "first");
            hint.innerText = "Viser ikke alle - præcisér din søgning";
            this.suggestionsList.appendChild(hint);
        }
        for (let i = 0; i < suggestions.length; i++) {
            const suggestion = suggestions[i];
            const listItem = document.createElement("li");
            listItem.id = fmko_ts_common_1.GlobalCounter.next();
            listItem.setAttribute("role", fmko_ts_common_1.ARIARole.OPTION);
            listItem.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
            if (this.isSuggestionFormatHtml) {
                listItem.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(this.formatSuggestion(suggestion));
            }
            else {
                listItem.textContent = this.formatSuggestion(suggestion);
            }
            listItem.addEventListener("mouseover", () => {
                if (DropdownUtil_1.default.dateHasPassedThreshold(this.lastScrollDate)) {
                    this.highlight(listItem);
                }
            });
            listItem.addEventListener("click", event => {
                event.preventDefault(); // Make sure input doesn't lose focus
                this.highlight(listItem);
                if (this.isShowingSuggestions() && this.currentLiHighlightedLi) {
                    this.hideSuggestions();
                    this.select(this.optionToIndexMap.get(listItem));
                }
            });
            if (i === 0) {
                this.currentLiHighlightedLi = listItem;
                this.highlight(this.currentLiHighlightedLi);
            }
            this.suggestionsElements.push(listItem);
            this.optionToIndexMap.set(listItem, i);
            this.suggestionsList.appendChild(listItem);
        }
        if (showSuggestions && suggestions.length > 0) {
            this.showSuggestions(true);
        }
    }
    parseValueFromInput(value) {
        // Not used, hence always return null to keep TS-compiler happy!
        return null;
    }
    setValueOnInput(newValue, input) {
        if (!newValue) {
            this._input.value = "";
        }
        else if (this.suggestions && this.suggestions.indexOf(newValue) > -1) {
            this.currentSelectionIndex = this.suggestions.indexOf(newValue);
            this.textFieldValueStr = this.format(newValue);
            this._input.value = this.textFieldValueStr;
            this.highlight(this.suggestionsElements[this.currentSelectionIndex]);
        }
        else {
            this.populateSuggestions([newValue], false, false);
            this.select(0);
            this.textFieldValueStr = this.format(newValue);
            this._input.value = this.textFieldValueStr;
        }
    }
    onTimerTriggered() {
        const query = this._input.value;
        if (query.length < this.minQueryLength) {
            this.populateSuggestions([], false, false);
        }
        else {
            this.search(query);
        }
    }
    select(selectionIndex) {
        if (this.currentSelectionIndex > -1) {
            const currentLi = this.suggestionsElements[this.currentSelectionIndex];
            currentLi.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
        }
        this.currentSelectionIndex = selectionIndex;
        if (this.currentSelectionIndex > -1) {
            const newLi = this.suggestionsElements[this.currentSelectionIndex];
            newLi.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "true");
        }
        this.setValue(this.suggestions[selectionIndex], true);
    }
    handleOnKeyDown(event) {
        let element = undefined;
        if (!this.suggestions.length) {
            return;
        }
        if (!KeyCode.hasModifierKey(event) && this.currentLiHighlightedLi) {
            if (KeyCode.isArrowDown(event)) {
                element = this.findEnabledAdjacentSibling(this.currentLiHighlightedLi, "next");
            }
            else if (KeyCode.isArrowUp(event)) {
                element = this.findEnabledAdjacentSibling(this.currentLiHighlightedLi, "previous");
            }
            else if (KeyCode.isHome(event)) {
                element = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[0];
            }
            else if (KeyCode.isEnd(event)) {
                element = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[this.suggestions.length - 1];
            }
            if (element) {
                event.preventDefault();
                if (!this.isShowingSuggestions()) {
                    this.showSuggestions(false);
                }
                this.highlight(element);
                this.scrollIntoView(element);
            }
        }
        if (KeyCode.isTab(event) && this.isShowingSuggestions()) {
            this.hideSuggestions();
            event.stopPropagation();
        }
    }
    handleOnKeyUp(event) {
        if (KeyCode.isEscape(event) && this.isShowingSuggestions()) {
            this.hideSuggestions();
            this.reset();
            event.stopPropagation();
            return;
        }
        else if (KeyCode.isEnter(event)) {
            if (this.isShowingSuggestions()) {
                if (this.currentLiHighlightedLi) {
                    this.hideSuggestions();
                    this.select(this.optionToIndexMap.get(this.currentLiHighlightedLi));
                }
                else if (this.suggestions?.length === 1) {
                    this.hideSuggestions();
                    this.select(0);
                }
            }
            else {
                this.showSuggestions(false);
            }
            return;
        }
        const input = event.target;
        const newValue = input.value;
        if (!this.textFieldValueStr || this.textFieldValueStr !== newValue) {
            this.textFieldValueStr = newValue;
            this.timer.schedule(AutoSuggestBox.SEARCH_TIMER);
            this.onQueryStringChanged();
        }
    }
    addListeners(input) {
        input.addEventListener("keydown", (event) => {
            this.handleOnKeyDown(event);
        });
        input.addEventListener("keyup", event => {
            this.handleOnKeyUp(event);
        });
        input.addEventListener("click", () => {
            if (!this.isShowingSuggestions()) {
                this.showSuggestions(false);
            }
        });
        input.addEventListener("blur", (event) => {
            if (this.isShowingSuggestions()) {
                this.hideSuggestions();
                if (this.suggestions && this.suggestions.length === 1) {
                    this.select(0);
                }
            }
            if (this.blurHandlers) {
                for (let handler of this.blurHandlers) {
                    handler(event);
                }
            }
            if (this.isOutOfSync()) {
                this.setValue(undefined, true);
            }
        });
        input.addEventListener("focus", () => {
            const value = input.value;
            if (value && value.length > 0) {
                input.select();
                this.showSuggestions(false);
            }
        });
    }
    scrollIntoView(element) {
        if (element) {
            const index = this.optionToIndexMap.get(element);
            const elementHeight = element.getBoundingClientRect().height;
            const offsetHeight = this.moreSuggestions ? elementHeight : 0;
            const scrollTo = (elementHeight * index) + offsetHeight;
            const listTop = this.suggestionsList.scrollTop;
            const listHeight = this.suggestionsList.clientHeight;
            const listBottom = listTop + listHeight;
            if (scrollTo < listTop) {
                this.suggestionsList.scrollTop = scrollTo;
            }
            if (scrollTo >= listBottom) {
                this.suggestionsList.scrollTop = (scrollTo + elementHeight) - listHeight;
            }
            this.lastScrollDate = new Date();
        }
    }
    showSuggestions(scrollToTop) {
        (0, fmko_ts_common_1.setElementVisible)(this.suggestionsList, true);
        this.renderTopOrBottom();
        if (scrollToTop) {
            this.suggestionsList.scrollTop = 0;
        }
        this.showingSuggestions = true;
        this.lastScrollDate = new Date();
        this.element.setAttribute(fmko_ts_common_1.ARIA.EXPANDED, "true");
        window.addEventListener("scroll", this.scrollListener, true);
    }
    highlight(newLi) {
        if (this.currentLiHighlightedLi) {
            this.suggestionsList.removeAttribute(fmko_ts_common_1.ARIA.ACTIVE_DESCENDANTS);
            this.currentLiHighlightedLi.classList.remove("dropdown-li-highlighted");
            this.currentLiHighlightedLi = undefined;
        }
        this.currentLiHighlightedLi = newLi;
        if (newLi) {
            this.suggestionsList.setAttribute(fmko_ts_common_1.ARIA.ACTIVE_DESCENDANTS, newLi.id);
            newLi.classList.add("dropdown-li-highlighted");
        }
    }
    renderTopOrBottom() {
        const buttonBottom = this._input.getBoundingClientRect().bottom;
        const dropdownHeight = this.suggestionsList.getBoundingClientRect().height;
        const windowTotalHeight = window.innerHeight;
        const dropDownOutsideOfView = buttonBottom + dropdownHeight > windowTotalHeight;
        this.suggestionsList.classList.toggle("render-dropdown-on-top", dropDownOutsideOfView);
    }
    findEnabledAdjacentSibling(element, direction, originalElement) {
        if (element === originalElement) {
            return originalElement; // We have iterated through the entire list of children
        }
        const relevantOriginalElement = originalElement || element;
        const adjacentIndex = direction === "previous" ? -1 : 1;
        const optionIndex = this.optionToIndexMap.get(element);
        const nextIndex = optionIndex + adjacentIndex;
        let adjacentElement;
        if (nextIndex > -1) {
            // Either the element is next in the array, or we are at this.optionElements.length, thus we have to reset to 0
            adjacentElement = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[nextIndex % this.suggestions.length];
        }
        else {
            // If we are -1, then we need to go to the end again
            adjacentElement = DropdownUtil_1.default.getOptionIndexMapKeys(this.optionToIndexMap)[this.suggestions.length - 1];
        }
        return this.getElementOrFindAdjacent(direction, adjacentElement, relevantOriginalElement);
    }
    getElementOrFindAdjacent(direction, element, originalElement) {
        if (element) {
            if (!element.hasAttribute("disabled")) {
                return element;
            }
            else {
                // If it's the first recursion then add element as original element
                this.findEnabledAdjacentSibling(element, direction, originalElement);
            }
        }
    }
}
AutoSuggestBox.SEARCH_TIMER = 400;
exports.default = AutoSuggestBox;
//# sourceMappingURL=AutoSuggestBox.js.map